'use client';

import { NOT_FOUND_RECIRC_HEADING, NOT_FOUND_RECIRC_TRACKING } from 'constants/404Recirculation';
import { ArticleSectionRelated } from '@/app_components/ArticleSections/ArticleSectionRelated';
import type { ArticlePreview, ArticlePreviewMostPopular } from '@/app_lib/types/ArticlePreview';
import type { EventData } from '@/app_lib/types/Gtm';
import { mostPopularToArticlePreview } from '@/app_lib/utils/pages/mostPopularToArticlePreview';

export const NotFoundRecirculation = ({ articles: raw }: { articles: ArticlePreviewMostPopular[] }) => {
  const articles = raw.map(mostPopularToArticlePreview).filter((article): article is ArticlePreview => article != null);

  if (!articles.length) {
    return null;
  }

  const trackingData: EventData = NOT_FOUND_RECIRC_TRACKING;

  return (
    <ArticleSectionRelated
      articles={articles}
      heading={NOT_FOUND_RECIRC_HEADING}
      trackingData={trackingData}
    />
  );
};
